import { createAction } from "@reduxjs/toolkit";
export var ActionTypes;
(function (ActionTypes) {
    ActionTypes["fetchOutbound"] = "searchResultsBounds/fetchOutbound";
    ActionTypes["fetchInbound"] = "searchResultsBounds/fetchInbound";
    ActionTypes["fetchSuccessOutbound"] = "searchResultsBounds/fetchSuccessOutbound";
    ActionTypes["fetchSuccessInbound"] = "searchResultsBounds/fetchSuccessInbound";
    ActionTypes["fetchErrorOutbound"] = "searchResultsBounds/fetchErrorOutbound";
    ActionTypes["fetchErrorInbound"] = "searchResultsBounds/fetchErrorInbound";
    ActionTypes["resetOutbound"] = "searchResultsBounds/resetOutbound";
    ActionTypes["resetInbound"] = "searchResultsBounds/resetInbound";
    ActionTypes["resetAllBounds"] = "searchResultsBounds/resetAllBounds";
})(ActionTypes || (ActionTypes = {}));
export const actions = {
    fetchOutbound: createAction(ActionTypes.fetchOutbound, () => ({
        payload: {}
    })),
    fetchInbound: createAction(ActionTypes.fetchInbound, () => ({
        payload: {}
    })),
    fetchSuccessOutbound: createAction(ActionTypes.fetchSuccessOutbound, (data) => ({
        payload: data
    })),
    fetchSuccessInbound: createAction(ActionTypes.fetchSuccessInbound, (data) => ({
        payload: data
    })),
    fetchErrorOutbound: createAction(ActionTypes.fetchErrorOutbound, (error) => ({
        payload: error
    })),
    fetchErrorInbound: createAction(ActionTypes.fetchErrorInbound, (error) => ({
        payload: error
    })),
    resetOutbound: createAction(ActionTypes.resetOutbound, () => ({
        payload: {}
    })),
    resetInbound: createAction(ActionTypes.resetInbound, () => ({
        payload: {}
    })),
    resetAllBounds: createAction(ActionTypes.resetAllBounds, () => ({
        payload: {}
    }))
};
